/**
 * Print Hub client helpers — staff devices (incl. iPhones) enqueue print
 * jobs to the database instead of driving the USB printer directly. The
 * master station (/print-hub) polls the queue and does the printing.
 */
import api, { withSite } from "@/lib/api";

/** Quick success buzz. Android/Chrome support the Vibration API; iOS
 *  Safari does not implement it, so on iPhone this is a silent no-op and
 *  we rely on the on-screen "Sent" confirmation instead. */
export function haptic(ms = 60) {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(ms);
    }
  } catch {
    /* ignore */
  }
}

function deviceLabel() {
  try {
    const ua = navigator.userAgent || "";
    if (/iPhone/i.test(ua)) return "iPhone";
    if (/iPad/i.test(ua)) return "iPad";
    if (/Android/i.test(ua)) return "Android";
    if (/Macintosh/i.test(ua)) return "Mac";
    if (/Windows/i.test(ua)) return "PC";
    return ua.slice(0, 40);
  } catch {
    return "device";
  }
}

/** Push one print job to the Hub queue for a site. */
export async function enqueuePrint(siteId, { label_type, product_name, copies, payload }) {
  const { data } = await api.post(
    "/print-queue",
    {
      label_type,
      product_name: product_name || "",
      copies: copies || 1,
      payload,
      source_device: deviceLabel(),
    },
    withSite(siteId),
  );
  return data;
}
